import { render, staticRenderFns } from "./BookmarksContainer.vue?vue&type=template&id=01fd39fd&scoped=true&"
import script from "./BookmarksContainer.vue?vue&type=script&lang=js&"
export * from "./BookmarksContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fd39fd",
  null
  
)

export default component.exports